(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("echarts"), require("react"), require("react-dom"), require("prop-types"));
	else if(typeof define === 'function' && define.amd)
		define(["echarts", "react", "react-dom", "prop-types"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("echarts"), require("react"), require("react-dom"), require("prop-types")) : factory(root["echarts"], root["React"], root["ReactDOM"], root["PropTypes"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_4__, __WEBPACK_EXTERNAL_MODULE_13__, __WEBPACK_EXTERNAL_MODULE_14__, __WEBPACK_EXTERNAL_MODULE_15__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition